"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _definitionhelpers = require("../../../utils/definitionhelpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// utils

/* ++++++++++ --------------- TEXT AND GRAPHIC LAYOUT : DEFINITION --------------- ++++++++++ */


var _default = {
  name: 'TextAndGraphicLayout',
  group: _definitionhelpers.groupNames.layouts,
  props: {
    headline: {
      type: 'object',
      default: 'Headline'
    },
    title: {
      type: 'object',
      default: 'Title'
    },
    bodycopy: {
      type: 'object',
      default: _react.default.createElement("p", null, "This is some body copy in a paragraph. You could also have a list items here.")
    },
    additionalMessageContent: {
      type: 'object',
      default: _react.default.createElement("div", {
        className: 'sample'
      }, "This is additional message content and can be any markup you want")
    },
    illustration: {
      type: 'string',
      default: 'product-commenting'
    },
    additionalVisualContent: {
      type: 'object',
      default: _react.default.createElement("div", {
        className: 'sample'
      }, "This is additional visual content and can be any markup you want")
    }
  }
};
exports.default = _default;